<template>
    <select-dropdown
        v-model="filterFields.jobIds"
        multiple
        searchable
        remove-icon
        can-select-all
        :loading="fetching"
        :autoTranslate="false"
        :limited-items-count="5"
        :truncate="true"
        :options="jobs"
        :placeholder="$t('form.dropdown.placeholder').toString()"
        :statuses="statuses"
    >
    </select-dropdown>
</template>

<script>
import Loading from '../ui/Loading.vue';
import Toggle from '../forms/Toggle.vue';
import SelectDropdown from "../forms/SelectDropdown";
import * as jobFunctions from "../../services/JobFunctionService";
import {normalizeJson, ucfirst} from "../../../shared/helpers";
import JobFunction from "../../models/JobFunction";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';

export default {
    name: 'FilterJobs',
    components: {
        Loading,
        Toggle,
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object}
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        jobs() {
            return useRepo(JobFunction)
                .where('title', (title) => title[this.locale])
                .orderBy('title_lowercased')
                .get().map(job => ({
                    value: job.id,
                    label: job.title[this.locale] + (job.city ? ' - ' + job.city : ''),
                    status: this.getJobStatus(job),
                    icon: this.getJobStatusIcon(job),
                }));
        },
    },
    data() {
        return {
            fetching: true,
            filteredStatus: 'all',
            statuses: [
                {
                    label: this.$t('analytics.show_all_jobs'),
                    value: 'all',
                    attribute: 'title_lowercased',
                    delimiter: (value) => value
                },
                {
                    label: ucfirst(this.$t('jobs.published')),
                    value: 'published',
                    attribute: 'published',
                    delimiter: (value) => value
                },
                {
                    label: ucfirst(this.$t('jobs.unpublished')),
                    value: 'unpublished',
                    attribute: 'published',
                    delimiter: (value) => !value
                },
                {
                    label: ucfirst(this.$t('analytics.archived')),
                    value: 'archived',
                    attribute: 'archived',
                    delimiter: (value) => value
                }
            ],
        }
    },
    methods: {
        getAttributeFromStatus(status) {
            return this.statuses.find(s => s.value === status).attribute;
        },
        getDelimiterFromStatus(status) {
            return this.statuses.find(s => s.value === status).delimiter;
        },
        getJobStatus(job) {
            if (job.published) {
                return this.$t('jobs.published')
            }
            if (job.archived) {
                return this.$t('analytics.archived')
            }
            if (!job.published) {
                return this.$t('jobs.unpublished')
            }
        },
        getJobStatusIcon(job) {
            if (job.published) {
                return {
                    type: 'check-circle',
                    style: 'opacity-75 text-secondary',
                    info: this.$t('jobs.published')
                }
            }

            if (job.archived) {
                return {
                    type: 'archive',
                    style: 'opacity-75 text-semantic-error',
                    info: this.$t('analytics.archived')
                }
            }

            if (!job.published) {
                return {
                    type: 'check-circle',
                    style: 'opacity-75 text-semantic-error',
                    info: this.$t('jobs.unpublished')
                }
            }
        },
        jobLocation(job) {
            let location = job.city;
            if (job.location)
                location = job.location.city;

            return location || null;
        },
        fetch() {
            this.fetching = true;

            jobFunctions.index()
                .then(result => {
                    let data = normalizeJson(result.data);

                    //Possible fix on TypeError .forEach is not a function
                    //.forEach requires an Array
                    if (data && typeof (data) === "string") {
                        data = JSON.parse(data)
                    }

                    // set translated title so we can order on it
                    data.forEach(job => {
                        job.title_translated = job.title ? (job.title[this.locale] || '') : '';
                        job.city = this.jobLocation(job);
                    })

                    return useRepo(JobFunction).save(data);
                })
                .then(() => {
                    this.fetching = false;
                });
        },
    },
    mounted () {
        this.fetch();
    }
}
</script>
